module.exports = __webpack_public_path__ + "img/symbol_8.cde826d5.png";